<template>
  <div class="dialog-pagination">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="Pagination.page"
      :page-size="Pagination.page_size"
      layout="prev, pager, next"
      :total="Pagination.total"
      background
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["Pagination"],
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-pagination {
  text-align: center;
  margin: 16px 0 30px;
  padding-bottom: 20px;
}
::v-deep(.el-pagination .btn-next),
::v-deep(.el-pagination .btn-prev) {
  width: 76px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #dedede;
  position: relative;
  background: #fff;
  color: #999;
}
::v-deep(.el-pagination .btn-prev::after) {
  content: "上一页";
  position: absolute;
  left: 23px;
  top: 0;
}
::v-deep(.el-pagination .btn-next::after) {
  content: "下一页";
  position: absolute;
  right: 23px;
  top: 0;
}
::v-deep(.el-pagination .btn-next .el-icon),
::v-deep(.el-pagination .btn-prev .el-icon) {
  display: inline-block;
  position: absolute;
}
::v-deep(.el-pagination .btn-next .el-icon) {
  right: 10px;
  top: 11px;
}
::v-deep(.el-pagination .btn-prev .el-icon) {
  left: 10px;
  top: 11px;
}
::v-deep(.el-pagination.is-background .el-pager li) {
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dedede;
}
</style>
